import Resource from "./resource";

export class BuiltInRepositoryConfigurationResource extends Resource {
    DeleteUnreleasedPackagesAfterDays?: number;
}

export default BuiltInRepositoryConfigurationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/builtInRepositoryConfigurationResource.ts